import React from 'react';
import {getStyle} from '../../utils/StyleUtils';

export const InternetDisconnected = () => {
  return <div className={getStyle('internet-disconnected-container')}>
    No internet connection
  </div>;
};
